module.exports = "https://service.ai-x-supporter.com/dinos_faq/static/img/sai-icon_scroll.d9312c8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resource/sai-icon_scroll.gif
// module id = M8y0
// module chunks = 0